// game-objects
import { SkySymbol } from "@aceroll/core";

// services
import { soundService } from "@aceroll/core";

export class Multiplier extends SkySymbol {
    async land() {
        return;
    }

    async multiply() {
        const { sounds } = this.config.default;

        if (sounds.multiply) {
            soundService.play(sounds.multiply);
        }

        await this.win();
    }
}